<span class="fyi" *ngIf="isShown">{{ message }}</span>
